module.exports = __webpack_public_path__ + "img/message-filter.e6283baa.png";